export default "__VITE_ASSET__CHyYv3p$__"